<div class="mobile-loading-screen">
  <div class="text-center logo">
    <a href="#">
      <img [src]="logoPath" alt="logo" />
    </a>
  </div>
  <div class="text-center d-flex flex-column justify-content-center main-content">
    <h4 class="mb-3 text-default">
      Retrieving Your<br />
      {{ uiConfig().planLabel }}
      <ng-container *ngIf="providerName">
        <span>With</span><br />
        <span [innerHTML]="providerName"></span>
      </ng-container>
    </h4>

    @if (showKycDesc()) {
      <p class="mb-3">
        Please ensure you have your identification available to complete your application.
      </p>
    }
    <div class="pt-3">
      <sliqpay-dot-loader theme="primary"></sliqpay-dot-loader>
    </div>

    <p class="pt-5">Completing this application will take approximately 2 minutes.</p>
  </div>
</div>
